<template>
    <MyFormVue addTitle="Upload New Video" updateTitle="Update Video" :submitLoading="submitLoading"
        :isUpdating="dataObj == null" accept=".mp4,.mkv,.mp3,.m4a" :step="step_no" :step_count="1" @submit="submit"
        @onFileInit="initFile" @closeModal="$emit('closeModal'), $emit('refresh')" @uploadFinished="uploadFinished"
        :showUploadOtherButton="true"></MyFormVue>
</template>

<script>
import MyFormVue from '../components/UploaderMyForm.vue';
export default {
    components: { MyFormVue },
    props: {
        dataObj: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            step_no: 1,
            submitLoading: false,
            form: {
                mediaId: null,
            },
            isUploadingFinished: false,
        }
    },
    mounted() {
        let vm = this;
        vm.form = {
            mediaId: null,
        }

    },
    computed: {
    },
    methods: {
        initFile(mediaId) {
            let vm = this;
            vm.form.mediaId = mediaId;
        },
        uploadFinished(isFinished) {
            let vm = this;
            console.log('isFinished', isFinished);
            vm.isUploadingFinished = isFinished;
        },
        submit() {
            let vm = this;
            if (vm.form.mediaId) {
                let vm = this;
                if (!vm.isUploadingFinished) {
                    vm.$notify({
                        group: "status",
                        type: "warn",
                        title: "OOPS!!!",
                        text: 'Waiting for upload to finish',
                    });
                    return;
                }
                vm.$emit('closeModal');
                vm.$emit('refresh');
            } else {
                vm.$notify({
                    group: "status",
                    type: "warn",
                    title: "OOPS!!!",
                    text: 'Please upload a video',
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main_modal {
    position: fixed;
    width: 100%;
    height: calc(100% - 60px);
    background: rgba(0, 0, 0, 0.268);
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    align-items: center;
    overflow-y: scroll;
    transition: .8s;
    z-index: 20;

    @media (max-height: 859px) {
        align-items: flex-start;
    }

    @media (max-width: 450px) {
        padding: 0;
    }

    &.activeSide {
        width: calc(100% - 230px);

        @media (max-width: 966px) {
            width: 100%;
        }

        .main_modal_crd {
            .modal_body {
                .modal_body_part {
                    &.split_step {
                        @media (max-width: 1162px) {
                            grid-template-columns: 58% 40%;
                        }

                        @media (max-width: 768px) {
                            grid-template-columns: 100%;
                            row-gap: 20px;
                        }
                    }
                }
            }
        }
    }

    .main_modal_crd {
        width: 90%;
        background: white;
        min-height: 300px;
        height: fit-content;
        border-radius: 10px;
        position: relative;
        overflow: hidden;

        @media (max-width: 580px) {
            width: 95%;
        }

        @media (max-width: 450px) {
            width: 100%;
            border-radius: 0;
            height: calc(100vh - 60px);
        }

        .modal_top {
            display: flex;
            padding: 16px 23px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #dfdfdf;
            position: sticky;
            top: 0;

            h1 {
                font-size: 17px;
                font-weight: 600;
            }

            span {
                cursor: pointer;
            }
        }

        .modal_body {
            height: 550px;
            overflow-y: auto;
            padding: 10px 23px 75px;

            @media (max-width: 580px) {
                padding-bottom: 100px;
            }

            @media (max-width: 450px) {
                padding-bottom: 75px;
                height: 88%;
            }

            .modal_body_part {
                &.upload_step {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;

                    .upload_cover {
                        display: flex;
                        width: 90px;
                        height: 90px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 50%;
                        background: #D9D9D9;
                        margin-bottom: 20px;
                    }

                    h1 {
                        font-weight: 600;
                        margin-bottom: 5px;
                    }

                    p {
                        opacity: .7;
                        text-align: center;
                        // margin-bottom: 20px;
                    }

                    .upload-trigger {
                        width: 40%;
                        margin-top: 20px;
                    }
                }

                &.split_step {
                    display: grid;
                    grid-template-columns: 68% 30%;
                    justify-content: space-between;

                    @media (max-width: 1000px) {
                        grid-template-columns: 58% 40%;
                    }

                    @media (max-width: 768px) {
                        grid-template-columns: 100%;
                        row-gap: 20px;
                    }

                    .split_part_data {
                        h1.title {
                            margin-bottom: 15px;
                            font-size: 23px;
                        }

                        .b-field-txt {
                            opacity: .6;

                            // display: flex;
                            &.mbottom {
                                margin-bottom: 10px;
                            }
                        }

                        .taginput.control {
                            display: flex;
                        }

                        .upload-trigger {
                            width: 200px;
                        }

                        .visibility-grp {
                            .visibility-grp-title {
                                font-weight: 700;
                            }

                            .visibility-grp-sub {
                                opacity: .7;
                            }

                            .visibility-togglers {
                                margin-top: 10px;
                                display: flex;
                                flex-direction: column;
                                row-gap: 10px;
                                padding-left: 40px;

                                .visibility-togglers-each {
                                    h1 {
                                        display: flex;
                                    }
                                }
                            }
                        }
                    }

                    .split_part_view {
                        .data_cover {
                            height: 300px;
                            border-radius: 10px;
                            overflow: hidden;
                            position: relative;
                            margin-bottom: 13px;

                            .b-skeleton {
                                height: 100%;

                                .b-skeleton-item {
                                    height: 100%;
                                }
                            }

                            img {
                                height: 100%;
                                width: 100%;
                                object-fit: cover;
                            }

                            .media {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 50px;
                                height: 50px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                background: white;
                                border-radius: 50%;
                                cursor: pointer;
                                box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);
                            }

                            .media-visibility-status {
                                position: absolute;
                                bottom: 20px;
                                right: 20px;
                                padding: 6px 13px;
                                font-size: 15px;
                                border-radius: 3px;
                                text-transform: capitalize;
                            }
                        }

                        h1.name {
                            font-weight: 600;
                            font-size: 20px;
                            margin-bottom: 13px;
                        }

                        p.descr {
                            font-size: 16px;
                            opacity: .7;
                            margin-bottom: 15px;
                        }

                        .spaced-skeleton {
                            margin-bottom: 15px;
                        }

                        .split_data_pt {
                            display: flex;
                            flex-direction: column;
                            row-gap: 10px;

                            .split_data_pt_crd {
                                display: flex;
                                font-size: 15px;

                                .split_data_pt_crd_more {
                                    margin-left: 5px;

                                    .b-skeleton {
                                        height: 100%;

                                        .b-skeleton-item {
                                            width: 200px;
                                        }
                                    }

                                    span {
                                        i {
                                            display: inline-flex;
                                            margin: 0 2px;
                                        }

                                        &:last-of-type {
                                            i {
                                                display: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .modal_footer {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 10px 23px;
            align-items: center;
            background: white;
            z-index: 10;
            border-top: 1px solid #dfdfdf;

            @media (max-width: 580px) {
                flex-direction: column;
                row-gap: 5px;
            }

            span {
                display: flex;
                align-items: center;
            }

            .actions {
                display: flex;
                align-items: center;
                column-gap: 20px;

                @media (max-width: 580px) {
                    width: 100%;
                    justify-content: space-between;
                }
            }
        }
    }
}
</style>